import CaretRight from 'components/icons/navigation/CaretRight';

const GraceListRowButton = ({ option, onClick }) => {
  return (
    <button
      data-testid={`option-button-${option.id}`}
      className="btn btnSecondary my-2 flex w-full content-center border-charcoal-60 p-4 hover:bg-charcoal-50"
      onClick={() => onClick(option.id)}
    >
      <span className="textMd text-secondary flex flex-grow self-center text-left">
        {option.name}
      </span>
      <CaretRight className="iconMd ml-4 self-center" />
    </button>
  );
};

GraceListRowButton.propTypes = {
  option: PropTypes.any,
  onClick: PropTypes.func,
};

export default GraceListRowButton;
